import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home'
import PecManager from './views/PecManager'
import StatusManager from './views/StatusManager'
import PecHistory from './views/PecHistory'
import NotAuthorized from './views/NotAuthorized'
import SignOut from './views/SignOut'
import UsersManager from './views/UsersManager'
import ModelesManager from './views/ModelesManager'
import ReparationTypeManager from './views/ReparationTypeManager'
import NotFound from './views/NotFound'
import Sync from './views/Sync'

Vue.use(Router)

export default new Router({
  mode: 'history',
  linkActiveClass: "",
  linkExactActiveClass: "active",
  base: process.env.NODE_ENV === 'production' ? "/crm" : "/",
  routes: [
    {
      path: '/',
      name: 'accueil',
      redirect: { name: 'pecManager' }
      // component: Home
    },
    {
      path: '/signout',
      name: 'signout',
      component: SignOut
    },
    {
      path: '/prise-en-charge/search/:search/:id?',
      name: 'search',
      component: PecManager,
      props: true
    },
    {
      path: '/prise-en-charge/new',
      name: 'pecManagerNew',
      component: PecManager,
      props: {
        showEditor: true
      }
    },
    {
      path: '/prise-en-charge/:id?',
      name: 'pecManager',
      component: PecManager,
      props: true
    },
    {
      path: '/prise-en-charge/status/:status_id/:id?',
      name: 'pecManagerFilteredByStatus',
      component: PecManager,
      props: true
    },
    {
      path: '/prise-en-charge-history/:id/:statusId?',
      name: 'PecHistory',
      component: PecHistory,
      props: true
    },
    {
      path: '/status/new',
      name: 'statusManagerNew',
      component: StatusManager,
      props: {
        showEditor: true
      }
    },
    {
      path: '/status/:id?',
      name: 'statusManager',
      component: StatusManager,
      props: true
    },
    {
      path: '/users/new',
      name: 'usersManagerNew',
      component: UsersManager,
      props: {
        showEditor: true
      }
    },
    {
      path: '/users/:id?',
      name: 'usersManager',
      component: UsersManager,
      props: true
    },
    {
      path: '/modeles/new',
      name: 'modelesManagerNew',
      component: ModelesManager,
      props: {
        showEditor: true
      }
    },
    {
      path: '/modeles/:id?',
      name: 'modelesManager',
      component: ModelesManager,
      props: true
    },
    
    {
      path: '/reparations/type/new',
      name: 'reparationTypeManagerNew',
      component: ReparationTypeManager,
      props: {
        showEditor: true
      }
    },
    {
      path: '/reparations/type/:id?',
      name: 'reparationTypeManager',
      component: ReparationTypeManager,
      props: true
    },

    {
      path: '/unauthorized',
      name: '401',
      component: NotAuthorized
    },
    {
      path: '/sync',
      name: 'sync',
      component: Sync
    },
    {
      path: '*',
      name: '404',
      component: NotFound
    },
  ]
})
